var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let SupplierList = class SupplierList extends Vue {
    search = '';
    item = {
        id: 0,
        name: ""
    };
    filter = [];
    cardBtn = "";
    cardTitel = "";
    supplier = [];
    name = "";
    loading = false;
    dia = false;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = -1;
    color = "";
    headers = [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Aktionen', value: 'actions' },
    ];
    openCreateDia() {
        this.cardTitel = "Liferanten erstellen";
        this.cardBtn = "Liferanten erstellen";
        this.dia = true;
    }
    openEditDia(item) {
        this.item = item;
        this.name = item.name;
        this.cardTitel = "Liferanten bearbeiten";
        this.cardBtn = "Liferanten ändern";
        this.dia = true;
    }
    getSupplierist() {
        this.loading = true;
        this.setFilter('search', this.search);
        axios.get('/api/suppliers', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.supplier = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.supplier;
    }
    async edit() {
        this.item.name = this.name;
        await axios.put('/api/suppliers/' + this.item.id, { Supplier: this.item }).then((response) => {
            this.name = "";
            this.color = "green";
            this.text = "Der Lieferant wurde erfolgreich geändert oder angelegt";
            this.snackbar = true;
        }).catch((error) => {
            this.color = "red";
            this.text = "Der Lieferant wurde nicht erfolgreich geändert oder angelegt";
            this.snackbar = true;
        });
        this.clear();
        this.snackbar = false;
    }
    clear() {
        this.item = {
            id: 0,
            name: ""
        };
        this.name = "";
        this.dia = false;
    }
    async Delete(item) {
        if (confirm("Möchtest du wirklich den Lieferanten löschen?")) {
            await axios.delete('/api/suppliers/' + item.id).then((response) => {
                this.color = "green";
                this.text = "Der Lieferant wurde erfolgreich gelöscht";
                this.snackbar = true;
            }).catch((error) => {
                this.color = "red";
                this.text = "Der Lieferant wird in einem Auftrag verwendet. " +
                    "Deswegen kann dieser Auftrag nicht gelöscht werden";
                this.snackbar = true;
            });
            this.getSupplierist();
        }
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    watchOptions() {
        this.getSupplierist();
        this.clear();
    }
    watchSearch() {
        this.getSupplierist();
        this.clear();
    }
    watchItem() {
        this.getSupplierist();
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getSupplierist();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SupplierList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SupplierList.prototype, "watchSearch", null);
__decorate([
    Watch('item', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SupplierList.prototype, "watchItem", null);
SupplierList = __decorate([
    Component({
        name: "SupplierList",
    })
], SupplierList);
export default SupplierList;
